import { call, put } from "redux-saga/effects";

import { apiGeneral, notify } from "services";
import { ICreateRequest } from "interfaces/create-duck";
import { requestErrorHandler } from "utils";
import { CreateCaveatTypeActions } from "store/ducks/settings/caveat-types";

export function* createCaveatTypeRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.post,
      `/indent-caveat-types`,
      postData
    );

    const { data } = responseBody;
    yield put(CreateCaveatTypeActions.success(data));
    notify("success", "Tipo de ressalva cadastrado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CreateCaveatTypeActions.failure(errorMessage));
  }
}
